module.exports = __webpack_public_path__ + "static/img/video_ranking_list_avatar3.9ab1862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_ranking_list_avatar3.png
// module id = zURk
// module chunks = 1